/**
 * Shared model of the exam issuance wizard (legacy + new design): empty rows and the payload serializers.
 */
export const EMPTY_RANGE = { simanFrom: '', simanTo: '' };
export const EMPTY_LINK = { chelek: '', ranges: [{ ...EMPTY_RANGE }] };
export const EMPTY_MAX_RULE = { fromCode: '', toCode: '', maxQuestions: '' };
export const EMPTY_STAR_RULE = { fromCode: '', toCode: '', starEveryN: 0 };
export const CHELEK_OPTIONS = [
  { value: '', label: '—' },
  { value: 'אורח חיים', label: 'אורח חיים' },
  { value: 'יורה דעה', label: 'יורה דעה' },
  { value: 'אבן העזר', label: 'אבן העזר' },
  { value: 'חושן משפט', label: 'חושן משפט' },
];

/** שולח רק חלקים עם טווחים תקינים; ריק = ללא דריסה */
export function serializeLibraryLinks(links) {
  if (!Array.isArray(links) || !links.length) return undefined;
  const result = [];
  for (const link of links) {
    if (!link?.chelek) continue;
    const ranges = (link.ranges || [])
      .map((r) => ({
        simanFrom: Number(r.simanFrom),
        simanTo: Number(r.simanTo),
      }))
      .filter((r) => (
        Number.isFinite(r.simanFrom)
        && Number.isFinite(r.simanTo)
        && r.simanFrom >= 1
        && r.simanTo >= r.simanFrom
      ));
    if (!ranges.length) continue;
    result.push({ chelek: link.chelek, ranges });
  }
  return result.length ? result : undefined;
}

/** כללי טווח קוד תקינים בלבד */
export function serializeMaxQuestionRules(rules) {
  if (!Array.isArray(rules) || !rules.length) return undefined;
  const result = [];
  for (const r of rules) {
    const fromCode = Number(r.fromCode);
    const toCode = Number(r.toCode);
    if (!Number.isFinite(fromCode) || !Number.isFinite(toCode)) continue;
    if (fromCode < 0 || toCode < 0 || fromCode > toCode) continue;
    if (r.maxQuestions === '' || r.maxQuestions == null) continue;
    const maxQ = Number(r.maxQuestions);
    if (!Number.isFinite(maxQ) || maxQ < 0) continue;
    result.push({
      fromCode: Math.floor(fromCode),
      toCode: Math.floor(toCode),
      maxQuestions: Math.floor(maxQ),
    });
  }
  return result.length ? result : undefined;
}

/** כללי כוכבית לפי טווח קוד — starEveryN: 0 = ללא, ≥2 = דילוג */
export function serializeStarEveryNRules(rules) {
  if (!Array.isArray(rules) || !rules.length) return undefined;
  const result = [];
  for (const r of rules) {
    const fromCode = Number(r.fromCode);
    const toCode = Number(r.toCode);
    if (!Number.isFinite(fromCode) || !Number.isFinite(toCode)) continue;
    if (fromCode < 0 || toCode < 0 || fromCode > toCode) continue;
    if (r.starEveryN === '' || r.starEveryN == null) continue;
    const n = Number(r.starEveryN);
    if (!Number.isFinite(n) || n < 0) continue;
    const starEveryN = n < 2 ? 0 : Math.floor(n);
    result.push({
      fromCode: Math.floor(fromCode),
      toCode: Math.floor(toCode),
      starEveryN,
    });
  }
  return result.length ? result : undefined;
}
